module.exports = __webpack_public_path__ + "9cea710d4c0ded0050f7f2ff60de57fe.png";